export const MAX_PHOTO_BYTES = 15 * 1024 * 1024;

export type PhotoValidationError = "unsupported_type" | "file_too_large";

type PhotoCandidate = Pick<File, "type" | "size">;

const SUPPORTED_PHOTO_TYPES = new Set([
  "image/jpeg",
  "image/png",
  "image/webp",
]);

export function validatePhoto(
  file: PhotoCandidate,
): PhotoValidationError | undefined {
  if (!SUPPORTED_PHOTO_TYPES.has(file.type.toLocaleLowerCase())) {
    return "unsupported_type";
  }
  if (file.size > MAX_PHOTO_BYTES) {
    return "file_too_large";
  }
  return undefined;
}
